import { ActivityGoalEnum } from "../generated/graphql";

export type ActivityGoalKind =
  | ActivityGoalEnum.Cognitive
  | ActivityGoalEnum.Physical
  | ActivityGoalEnum.SocialAndCommunicative
  | ActivityGoalEnum.MentalWellbeing;

export type GoalProgress = { doneMinutes: number; weeklyGoalMinutes: number };

export type ActivityGoalProgressByKind = Record<ActivityGoalKind, GoalProgress>;

export const ACTIVITY_GOAL_KINDS: ActivityGoalKind[] = [
  ActivityGoalEnum.Cognitive,
  ActivityGoalEnum.Physical,
  ActivityGoalEnum.SocialAndCommunicative,
  ActivityGoalEnum.MentalWellbeing,
];
